import axios from 'axios';
import apiClient from './apiClient';

/**
 * Individual attribute value within a category.
 */
export interface CardAttributeValue {
  name: string;
  sortOrder: number;
  isAdminOnly: boolean;
}

/**
 * A category of card attributes with its match weight and values.
 */
export interface CardAttributeCategory {
  matchWeight: number;
  values: CardAttributeValue[];
}

/**
 * Response shape from GET /api/card-attributes.
 * Keys are camelCase category names (persona, tone, emotionalAngle, etc.).
 */
export type CardAttributesResponse = Record<string, CardAttributeCategory>;

/**
 * Fetches all active card attributes grouped by category.
 * Results are cached by the HTTP response cache (5 min) and by the
 * useCardAttributes hook at the module level.
 */
export async function getCardAttributes(): Promise<CardAttributesResponse> {
  const response = await apiClient.get<CardAttributesResponse>('/card-attributes');
  return response.data;
}

/**
 * Fetches card attributes from the public (unauthenticated) endpoint.
 * Used by the guest scheduling flow where the user hasn't signed in yet
 * but needs relationship/tone dropdowns to create a contact.
 */
export async function getPublicCardAttributes(): Promise<CardAttributesResponse> {
  const baseUrl = import.meta.env.VITE_API_URL || '/api';
  const response = await axios.get<CardAttributesResponse>(`${baseUrl}/public/card-attributes`);
  return response.data;
}
